module.exports = __webpack_public_path__ + "img/examine_img02.08ecf45e.png";